export const setPurchaseNumber = (payload: string | null) => ({
  type: 'SET_PURCHASE_NUMBER',
  payload,
});

export const setClientSecret = (payload: string | null) => ({
  type: 'SET_CLIENT_SECRET',
  payload,
});
